import { Text } from '@user-portal/wikr-components';
import {
    trackAcceptQuitButtonClick,
    trackDiscardQuitButtonClick,
    trackExerciseQuitModalLoad,
} from 'analytics/trackers/exercise';
import { useTranslation } from 'react-i18next';

import Modal from 'components/Modal';

import { useWorkoutContext } from 'pages/workout-page/hooks';

import * as S from './styled';

const ConfirmCancellation = ({ onClose, onSubmit }: { onClose: () => void; onSubmit: () => void }) => {
    const { t } = useTranslation();
    const { exerciseData, currentPlaylistPosition } = useWorkoutContext();

    const onCancelHandler = () => {
        trackDiscardQuitButtonClick(exerciseData.id, currentPlaylistPosition);
        onClose();
    };

    const onConfirmHandler = () => {
        trackAcceptQuitButtonClick(exerciseData.id, currentPlaylistPosition);
        onSubmit();
    };

    return (
        <Modal isOpen onClose={onCancelHandler} withCloseButton trackLoad={trackExerciseQuitModalLoad} width={384}>
            <Text type="h6" center mb={8}>
                {t('workout.confirmCancellation.title')}
            </Text>
            <Text type="medium-text" center mb={32}>
                {t('workout.confirmCancellation.subtitle')}
            </Text>
            <S.ButtonsWrp>
                <S.ConfirmButton size="small" onClick={onConfirmHandler}>
                    {t('basics.stop')}
                </S.ConfirmButton>
                <S.CancelButton size="small" onClick={onCancelHandler}>
                    {t('basics.continue')}
                </S.CancelButton>
            </S.ButtonsWrp>
        </Modal>
    );
};

export default ConfirmCancellation;
